import { transformOrgColumnIntoDataObject } from '../../../../backend/features/accounts/utils/transformOrgColumnIntoDataObject';
import { collectOrgIdsForAnyOrgPermission, requireAnySystemPermission, requireOrgPermission } from '../../../../backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
export function checkUserCanManageChangedOrganizations(userState, accountId, data, prevData) {
    var _a, _b, _c;
    // Need to filter org list from prevData to match org list that comes from frontend
    const { orgRole: orgRoles, orgStatus: orgStatuses } = filterAccountOrganizationsByPermission(prevData, accountId, ['manage-members'], userState);
    const changedOrgRoleIds = (_a = getChangedOrgIds(data.orgRole, orgRoles)) !== null && _a !== void 0 ? _a : [];
    const changedOrgStatusIds = (_b = getChangedOrgIds(data.orgStatus, orgStatuses)) !== null && _b !== void 0 ? _b : [];
    const userAddedorRemovedOrgIds = (_c = getAddedOrRemovedOrgIds(data.orgRole, orgRoles)) !== null && _c !== void 0 ? _c : [];
    const changedOrgIds = [...new Set([...changedOrgRoleIds, ...changedOrgStatusIds, ...userAddedorRemovedOrgIds])];
    const isUserAccountOwner = userState.id === accountId;
    // Users should be able to withdraw or join an organization despite their permissions
    if (isUserAccountOwner && changedOrgStatusIds && changedOrgStatusIds.length > 0) {
        changedOrgStatusIds.forEach((statusId, index) => {
            const isUserWithdrawn = orgStatuses[statusId] !== 'withdrawn' && data.orgStatus[statusId] === 'withdrawn';
            const isUserPending = orgStatuses[statusId] !== 'pending' && data.orgStatus[statusId] === 'pending';
            if (isUserWithdrawn || isUserPending) {
                changedOrgIds.splice(index, 1);
            }
        });
    }
    checkManageMembersPermission(accountId, userState, changedOrgIds);
}
export function checkManageMembersPermission(accountId, userState, orgIds) {
    if (userState && orgIds) {
        orgIds.forEach((orgId) => {
            const canManageMembers = requireOrgPermission(userState, orgId, 'manage-members');
            if (!canManageMembers) {
                throw new AuthError('User is not allowed to change organization role or status');
            }
        });
    }
}
export function getChangedOrgIds(orgRoleOrStatus, prevOrgRoleOrStatus) {
    const orgRoleOrStatusEntries = Object.entries(orgRoleOrStatus);
    const prevOrgRoleOrStatusEntries = Object.entries(prevOrgRoleOrStatus);
    const orgIds = orgRoleOrStatusEntries
        .filter(([orgId, value]) => {
        return prevOrgRoleOrStatusEntries.find(([prevOrgId, prevValue]) => {
            const doIdsMatch = orgId === prevOrgId;
            const isValueChanged = value !== prevValue;
            return doIdsMatch && isValueChanged;
        });
    })
        .map(([orgId]) => orgId);
    return orgIds.length ? orgIds : undefined;
}
export function getAddedOrRemovedOrgIds(orgRole, prevOrgRole) {
    const currentOrgsIds = Object.keys(orgRole);
    const prevOrgIds = Object.keys(prevOrgRole);
    const orgIds = currentOrgsIds
        .filter((orgId) => !prevOrgIds.includes(orgId))
        .concat(prevOrgIds.filter((prevOrgId) => !currentOrgsIds.includes(prevOrgId)));
    return orgIds.length ? orgIds : undefined;
}
export function filterAccountOrganizationsByPermission(account, accountId, permission, userState) {
    let orgRoles = account.orgRole;
    let orgStatuses = account.orgStatus;
    if (requireAnySystemPermission(userState, 'manage-accounts')) {
        return { orgRole: orgRoles, orgStatus: orgStatuses };
    }
    if (userState && userState.id !== accountId) {
        const orgsUserCanManage = collectOrgIdsForAnyOrgPermission(userState, ...permission);
        const filteredOrgRoles = {};
        const filteredOrgStatus = {};
        for (const org in account.orgStatus) {
            if (orgsUserCanManage.includes(org)) {
                filteredOrgRoles[org] = account.orgRole[org];
                filteredOrgStatus[org] = account.orgStatus[org];
            }
        }
        orgRoles = filteredOrgRoles;
        orgStatuses = filteredOrgStatus;
    }
    return { orgRole: orgRoles, orgStatus: orgStatuses };
}
export function filterAccountColumnsOrganizationsByPermission(account, accountId, permission, userState) {
    let orgRoles = transformOrgColumnIntoDataObject(account.orgRole);
    let orgStatuses = transformOrgColumnIntoDataObject(account.orgStatus);
    if (requireAnySystemPermission(userState, 'manage-accounts')) {
        return { orgRole: orgRoles, orgStatus: orgStatuses };
    }
    if (userState && userState.id !== accountId) {
        const orgsUserCanManage = collectOrgIdsForAnyOrgPermission(userState, ...permission);
        const filteredOrgRoles = {};
        const filteredOrgStatus = {};
        for (const org in orgStatuses) {
            if (orgsUserCanManage.includes(org)) {
                filteredOrgRoles[org] = orgRoles[org];
                filteredOrgStatus[org] = orgStatuses[org];
            }
        }
        orgRoles = filteredOrgRoles;
        orgStatuses = filteredOrgStatus;
    }
    return { orgRole: orgRoles, orgStatus: orgStatuses };
}
export function getEffectiveReportingId(orgNetwork, id) {
    const v = orgNetwork[id];
    if (!v)
        return undefined;
    if (v.reportingId) {
        return v.reportingId;
    }
    if (v.directParentId) {
        return getEffectiveReportingId(orgNetwork, v.directParentId);
    }
    return undefined;
}
export function isUserRemovingLastOrganization(data, prevData) {
    return (!Object.keys(data.orgRole).length &&
        !Object.keys(data.orgStatus).length &&
        (!!Object.keys(prevData.orgRole).length || !!Object.keys(prevData.orgStatus).length));
}
